import { Cascader } from "antd";
import styled, { createGlobalStyle, css } from "styled-components";

export const StyledCascader = styled(Cascader)`
  .ant-select-selector {
    background: #2c2c31 !important;
    border: 1px solid var(--topup-recharge-input-border) !important;
    box-shadow: none !important;
  }
  height: 37px;
  border-radius: 3px;
  &:hover,
  &:active {
    box-shadow: 0 0 0 1px var(--main-color);
  }
`;
export const CascaderDropdown = createGlobalStyle`
  .ant-select-dropdown {
    background: #333336;
    color: rgba(255, 255, 255, 0.85);
    border-radius: 3px;
    padding: 0;
    border: 1px solid var(--topup-recharge-input-border);
  }
  .ant-cascader-dropdown .ant-cascader-menu:not(:last-child) {
    border-right: 1px solid var(--topup-recharge-input-border);
  }
  .ant-cascader-checkbox-inner {
    background: unset !important;
    border: 1px solid var(--topup-recharge-input-border) !important;
  }
  .ant-cascader-checkbox-checked {
    .ant-cascader-checkbox-inner {
      background: var(--main-color) !important;
      border-color: var(--main-color) !important;
    }
  }
  .ant-cascader-menu-item {
    background-color: #333336 !important;
    :hover {
      background: rgb(26, 28, 31) !important;
      .ant-cascader-checkbox-inner {
        border-color: var(--main-color) !important;
      }
    }
  }
  .ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner:after {
    background-color: unset !important;
  }
  .ant-empty-description {
    color: rgba(255, 255, 255, 0.85) !important;
  }
`;
